import {useState, useRef, useContext } from 'react';
import { Form, useActionData, redirect,useSearchParams } from "react-router-dom";

import PasswordRulesModal from '../components/Password/PasswordRulesModal';
import { updatePassword } from '../utils/api';
import { validateEntry } from '../utils/validation';

import MenuContext from '../store/MenuContext';
import HeaderClasses from '../components/AppHeader/AppHeader.module.css';
import RegisterClasses from '../components/Register/Register.module.css';


const ResetPassword = () => {
   	const actionData=useActionData();
	const [rules, setRules] = useState(false);
	const [error, setError] = useState({});
	const pwd = useRef(null);
	const verify = useRef(null);
	const [searchParams] = useSearchParams();
	const [doPasswordsMatch, setDoPasswordsMatch] = useState(true);
	const actCode=searchParams.get("token");
	const confirmPassword =  event => {
		if (pwd.current.value === verify.current.value &&
			pwd.current.value !== '') {
				setDoPasswordsMatch(true);
			}
		else {
			setDoPasswordsMatch(false);
		}
	}
	const validationHandler = (event) => {
		const validationType = event.target.dataset.validation;
		const valstring = event.target.value;
		const valerror=validateEntry(validationType,valstring);
		const fldname=event.target.name;
		if(valerror!=='') {
			setError(prevState => ({...prevState,[fldname]:valerror,}));
		}
	};
	const toggleRules = () =>{
		setRules(!rules);
	};
	const touchHandler = event =>{
		console.log(error);
		setDoPasswordsMatch(true);
	}
	const menuTheme = useContext(MenuContext);

    return (
    		<div className={RegisterClasses.testInfo}>
    		  <div className={RegisterClasses.testInfoContent}>
				<Form method='post'>
					<h1>Reset Password</h1>
					<div className={RegisterClasses['form-control']}>
						{actionData?.errors && <div className={HeaderClasses.error}>{actionData.errors}</div>}
						<label>Password:</label>
						<input ref={pwd} autoComplete="new-password" type='password' name='new-password' id='new-password' required='1'  
								  onBlur={validationHandler} data-validation='validatePassword' onTouch={touchHandler}
								/>
						<label>Confirm Password </label>
						<input autoComplete="new-password" type='password' ref={verify} name='Confirmnew-password' id='Confirmnew-password' required='1' 
						  onBlur={confirmPassword}  onTouch={touchHandler}
						  />
						<button onClick={toggleRules}>Password Rules</button>
						{rules && <PasswordRulesModal onClose={toggleRules}/>}
						<input type="hidden" name="actCode" defaultValue={actCode} />
						<nav className={HeaderClasses.headerNav}>
							<div className={RegisterClasses.buttonArea}>  
									<button className={RegisterClasses.buttonDarkBlue}>Submit</button>
				            </div>
						</nav>
						{error['new-password']&& <div>{error['new-password']}</div>}
						{!doPasswordsMatch && (	<p>Your password must be the same.</p> )}
					</div>
				</Form>
			</div>
		</div>
	);
};

export default ResetPassword;

export async function action({ request, params }) {
  const data = await request.formData();

  const messages={};
  const passwordData = {
	password: data.get('new-password'),
	token: data.get("actCode")
  };
  const resData = await updatePassword(passwordData);
  console.log(resData);
  
  if(resData.token) {
	 return redirect('../login');
  }else{
	  messages.errors="Could not update password.";
	  return messages;
  };

}
